import { TCashdesk } from 'shared/services/types/cashdesk.types';

export const MOCK_DATA_CASH_DESK: TCashdesk.CashdeskData[] = [
  {
    id: 0,
    name: 'test123',

    methods: [
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 }
    ]
  },
  {
    id: 1,
    name: 'test123',

    methods: [
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 }
    ]
  },
  {
    id: 2,
    name: 'test123',

    methods: [
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 }
    ]
  },
  {
    id: 3,
    name: 'test123',

    methods: [
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 }
    ]
  },
  {
    id: 0,
    name: 'test123',

    methods: [
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 }
    ]
  },
  {
    id: 0,
    name: 'test123',

    methods: [
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 }
    ]
  },
  {
    id: 0,
    name: 'test123',

    methods: [
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 }
    ]
  },
  {
    id: 0,
    name: 'test123',

    methods: [
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 }
    ]
  },
  {
    id: 0,
    name: 'test123',

    methods: [
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 }
    ]
  },
  {
    id: 0,
    name: 'test123',

    methods: [
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 }
    ]
  },
  {
    id: 0,
    name: 'test123',

    methods: [
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 }
    ]
  },
  {
    id: 0,
    name: 'test123',

    methods: [
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 }
    ]
  },
  {
    id: 0,
    name: 'test123',

    methods: [
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 }
    ]
  },
  {
    id: 0,
    name: 'test123',

    methods: [
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 }
    ]
  },
  {
    id: 0,
    name: 'test123',

    methods: [
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 }
    ]
  },
  {
    id: 0,
    name: 'test123',

    methods: [
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 }
    ]
  },
  {
    id: 0,
    name: 'test123',

    methods: [
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 },
      { name: 'test321', count: 687 }
    ]
  }
];
